var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10916",
    "data-name": "Group 10916",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.372,
    height: 15.478,
    viewBox: "0 0 100.372 15.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 16.25,
    height: 15.478,
    fill: "#ffdc00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609",
    "data-name": "Path 10609",
    d: "M12.64,15.474a.786.786,0,0,1-.372-.089L8.114,13.21,3.959,15.385a.815.815,0,0,1-1.18-.865l.814-4.584L.238,6.679a.82.82,0,0,1-.2-.814A.818.818,0,0,1,.7,5.313l4.64-.676L7.383.459a.811.811,0,0,1,1.461,0l2.071,4.17,4.641.677a.8.8,0,0,1,.455,1.367L12.656,9.93l.814,4.584a.8.8,0,0,1-.83.961",
    transform: "translate(0 0)",
    fill: "#ffdc00"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "star-2",
    "data-name": "star",
    transform: "translate(21.29 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-2",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-2",
    "data-name": "Path 10609",
    d: "M12.64,15.474a.786.786,0,0,1-.372-.089L8.114,13.21,3.959,15.385a.815.815,0,0,1-1.18-.865l.814-4.584L.238,6.679a.82.82,0,0,1-.2-.814A.818.818,0,0,1,.7,5.313l4.64-.676L7.383.459a.811.811,0,0,1,1.461,0l2.071,4.17,4.641.677a.8.8,0,0,1,.455,1.367L12.656,9.93l.814,4.584a.8.8,0,0,1-.83.961",
    transform: "translate(0 0)",
    fill: "#ffdc00"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "star-3",
    "data-name": "star",
    transform: "translate(42.061 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-3",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-3",
    "data-name": "Path 10609",
    d: "M12.64,15.474a.786.786,0,0,1-.372-.089L8.114,13.21,3.959,15.385a.815.815,0,0,1-1.18-.865l.814-4.584L.238,6.679a.82.82,0,0,1-.2-.814A.818.818,0,0,1,.7,5.313l4.64-.676L7.383.459a.811.811,0,0,1,1.461,0l2.071,4.17,4.641.677a.8.8,0,0,1,.455,1.367L12.656,9.93l.814,4.584a.8.8,0,0,1-.83.961",
    transform: "translate(0 0)",
    fill: "#ffdc00"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "star-4",
    "data-name": "star",
    transform: "translate(62.831 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-4",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-4",
    "data-name": "Path 10609",
    d: "M12.64,15.474a.786.786,0,0,1-.372-.089L8.114,13.21,3.959,15.385a.815.815,0,0,1-1.18-.865l.814-4.584L.238,6.679a.82.82,0,0,1-.2-.814A.818.818,0,0,1,.7,5.313l4.64-.676L7.383.459a.811.811,0,0,1,1.461,0l2.071,4.17,4.641.677a.8.8,0,0,1,.455,1.367L12.656,9.93l.814,4.584a.8.8,0,0,1-.83.961",
    transform: "translate(0 0)",
    fill: "#ffdc00"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "star-5",
    "data-name": "star",
    transform: "translate(84.121 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803-5",
    "data-name": "Group 2803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10609-5",
    "data-name": "Path 10609",
    d: "M12.64,15.474a.786.786,0,0,1-.372-.089L8.114,13.21,3.959,15.385a.815.815,0,0,1-1.18-.865l.814-4.584L.238,6.679a.82.82,0,0,1-.2-.814A.818.818,0,0,1,.7,5.313l4.64-.676L7.383.459a.811.811,0,0,1,1.461,0l2.071,4.17,4.641.677a.8.8,0,0,1,.455,1.367L12.656,9.93l.814,4.584a.8.8,0,0,1-.83.961",
    transform: "translate(0 0)",
    fill: "#ffdc00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.85abc83205f9e0fa0104e985e2133193.svg";
export { ForwardRef as ReactComponent };